import axios from 'axios';
import { baseURL } from '../../shared/helpers/axiosConfiguration';

export const getUptime = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/sysstats?api_key=setup_manager&uptime=1`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getServicesStatus = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/servicesstatuses?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getFirewallStatus = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/secstatuses?api_key=setup_manager&fw_statuses=1`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getHttpsStatus = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/secstatuses?api_key=setup_manager&https_statuses=1`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getVPNStatus = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/supportvpn?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getPasswordsStatus = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/secstatuses?api_key=setup_manager&passwords=1`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getPartitionStatus = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/maintenancestate?api_key=setup_manager&states=1`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getStorageUsage = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/maintenancestate?api_key=setup_manager&states=1`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getActiveCalls = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/sysstats?api_key=setup_manager&active_calls=1`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getUpdatesStatus = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/updates?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getDevicesUpdatesStatus = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/updates?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getCallsSummary = (from, to, periodUnit, period) => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/extendedcdrs?api_key=setup_manager&from=${from}&to=${to}&periodUnit=${periodUnit}&period=${period}`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});

export const getTotalCalls = () => axios({
    method: 'get',
    url: `${baseURL}/dws/dashboardapi/totalcalls?api_key=setup_manager`,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-adminapi-token': localStorage.getItem('token')
    }
});
